export default {
  "36e4f62deec034303579021f6ec892ab": "訂閲",
  "71f29e5f9823e57efcb829262e1d84e5": "分段購買",
  "7b2c7aa88886209ed2bb9889da1b1490": "一次性購買",
  "123777ea44c18e9fac04a80df1323aea": "訂閲方式選擇",
  "fabe953bc0b6f44b5df4617ece8bae0b": "特惠價",
  "282875e277b220b5e49351463a807b42": "推薦",
  "398efe4cb64f0e325f5a2d95e8a7bff9": "訂閲方式曝光",
  "1a305f88bacef6b37914cb04f2bc16e5": "摺合¥",
  "f1be5702b43b0f54d161edb2d2c4aeed": "/月",
  "3df9be06dbcccbb69ac936ced60a24c3": "不可購買",
  "218a0d0959e6f1ef46d1fdecb970d014": "次",
  "80c6793203630258599b26f24143759e": "續費"
}
